export default function TermsOfService() {
  return (
    <>
      <div className="px-6 py-32 bg-white lg:px-8">
        <div className="flex flex-col max-w-3xl mx-auto text-base text-gray-700 leading-2 gap-y-4">
          <h1 className="font-bold leading-10 text-center text-black">
            MC&E INC./ELECTIONSOURCE TERMS OF SERVICE FOR BALLOTCHART.COM ONLINE
            TEST CHART PREPARATION SERVICES
          </h1>
          <p className="text-center">Version 11272023</p>
          <p className="text-center underline">Introduction and Overview</p>
          <p>
            Thank you for choosing MC&E Inc. We provide software through
            BallotChart.com that includes a variety of services, including
            ballot chart preparation, and pre-marked test decks (each, a
            “Service”). MC&E Inc. is referred to in these provisions as “us."
          </p>
          <p>
            When you use BallotChart.com, you enter into a binding contract with
            us. Each section of the agreement begins with an italicized
            annotation that is intended to help you navigate the agreement. The
            annotations do not completely summarize the agreement, though, and
            you should read each section carefully and in full. We’ve also
            <strong> bolded</strong> a few areas that talk about important legal
            rights, and you should be sure to read those sections carefully.
            These provisions apply to the Platform generally.
          </p>
          <p>
            If you are an individual acting on your company’s or client’s
            behalf, you accept these provisions on their behalf and the term
            “you” will refer to you, your company, or your client.
          </p>
          <p className="underline">Agreement to These Terms</p>
          <p className="italic">
            You need to agree to these terms to use BallotChart.com. By using
            BallotChart.com, you are instructing us to share your data across
            our platform for marketing, eligibility and other purposes,
            consistent with applicable law.
          </p>
          <p>
            To access and/or use BallotChart.com, you acknowledge and agree:
          </p>
          <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
            <li>
              To the terms and conditions of this agreement (“Agreement”), which
              includes:
            </li>
            <ul className="pl-8 list-disc list-inside -indent-5">
              <li>
                Any additional provisions and conditions provided separately to
                you for your use of BallotChart.com, which may include terms and
                conditions from third parties (which we refer to as “Additional
                Terms”)
              </li>
            </ul>
            <li>You are at least 18 years of age;</li>
            <li>
              You represent a government entity such as state, county, city,
              town or township
            </li>
          </ul>
          <p className="underline">Changes</p>
          <p className="italic">
            Change happens. When it does happen, we will update this Agreement.
            If the changes are material, you may need to accept the changes to
            use BallotChart.com. Similarly, there may be circumstances where we
            need to update or discontinue BallotChart.com.
          </p>
          <p>
            We may modify the provisions of this Agreement at any time. We may
            notify you of such modifications by posting through BallotChart.com
            or on ElectionSource.com or by other means. It is important that you
            review this Agreement whenever we modify it because your continued
            use of BallotChart.com indicates your agreement to the modifications
          </p>
          <p>
            In some cases, you may need to accept changes to this Agreement to
            continue using BallotChart.com. If you do not agree to the changes,
            you may stop using BallotChart.com or terminate your account.
          </p>
          <p>
            Similarly, we may update BallotChart.com, including with tools,
            utilities, improvements or third-party applications. You agree to
            receive these updates. We may further modify, suspend or discontinue
            BallotChart.com at any time. You agree that we will not be liable to
            you or any third party for any modification, suspensions, or
            discontinuance of BallotChart.com.
          </p>
          <p className="underline">Your Rights to Use BallotChart.com</p>
          <p className="italic">
            You can use BallotChart.com for your own personal and lawful use or
            as otherwise permitted under this Agreement.
          </p>
          <p>
            Except as set forth in the Section B terms, you may access and use
            BallotChart.com for your own internal, lawful and government
            purposes only.
          </p>
          <p className="underline">Beta Features</p>
          <p className="italic">
            We may provide you with access to beta features in BallotChart.com.
            You are free to use them, but they are provided as-is.
          </p>
          <p>
            We may include new and/or updated pre-release and trial features in
            BallotChart.com, and such features are provided as-is. Your use of
            such features is at no additional cost, but you must follow
            additional rules or restrictions that we may place on their use.
          </p>
          <p className="underline">Account</p>
          <p className="italic">
            You will provide accurate, up-to-date account information and
            securely manage such information.
          </p>
          <p>
            You may need to sign up for an account to use BallotChart.com. We
            may need to verify your identity, and you authorize us to collect
            information (e.g., employer information, date of birth, address)
            from you to do so (collectively, with all information requested to
            enable your account, “Account Information”). You will provide
            accurate, up-to-date Account Information, and we disclaim any
            liability arising from your failure to do so. Such failure may
            further limit your ability to use BallotChart.com and affect the
            accuracy and effectiveness of BallotChart.com.
          </p>
          <p>
            You are responsible for securely managing your Account Information,
            including any password(s) for BallotChart.com. You will notify us
            immediately if you believe that your Account Information or device
            you use to access BallotChart.com has been lost or stolen, or that
            someone is using your account without your permission.
          </p>
          <p className="underline">Payment & Cancellations</p>
          <p className="italic">
            We will charge your payment method or invoice for services provided.
            You may cancel this service at any time (but you may not receive a
            refund).
          </p>
          <p>
            We may require payment of fees or a subscription charge for use of
            BallotChart.com and you agree to pay such fees. If you registered
            for a trial, you may need to purchase products produced before the
            trial ends in order to retain access to any content provided to, or
            created through, the Platform.
          </p>
          <p>
            Payments will be billed in U.S. dollars, and your account will be
            charged upon purchase and when you provide your payment information,
            unless stated otherwise in applicable payment provisions. If your
            payment information is not accurate, current and complete, we may
            suspend or terminate your account. If you do not notify us of
            updates to your payment information, we may participate in programs
            supported by your card provider to try to update your payment
            information, and you authorize us to continue billing your account
            with the updated information that we obtain.
          </p>
          <p>
            You may be charged a subscription fee in advance on an annual basis
            or other recurring interval disclosed to you prior to your purchase.
            For annual subscriptions, we will send you a reminder with the
            then-current subscription fee no less than thirty (30) days and no
            more than sixty (60) days before your subscription term ends, or
            otherwise as required by applicable law. MC&E Inc. may change the
            price for recurring subscription fees from time to time with notice
            to you. Price changes will take effect at the start of the next
            subscription period following the date of the price change. If you
            do not agree with the price change, you may unsubscribe prior to the
            price change going into effect.
          </p>
          <p>
            Your payment to MC&E Inc. will automatically renew at the end of the
            applicable subscription period, but you can cancel a subscription at
            any time. Subscription cancellations will take effect the day after
            the last day of the current subscription period. If you cancel in
            the middle of a subscription period, you will be able to continue to
            access and use the applicable Service until the end of your
            subscription period. We do not provide refunds or credits for any
            cancellations or partial subscription period.
          </p>
          <p className="underline">Desktop and Mobile App Use</p>
          <p className="italic">
            Desktop and Mobile versions of our Platform may be available for
            download, but you must follow applicable third-party terms when
            using them
          </p>
          <p>
            The Platform may be available through one or more apps for a
            compatible desktop computer or mobile device. You agree that you are
            solely responsible for any applicable changes, updates and fees as
            well as complying with the provisions of your agreement with your
            telecommunications provider and any third-party mobile app
            marketplace.
          </p>
          <p>
            With respect to the applicable Software, you are only granted
            limited rights to install and use the Software you have downloaded,
            signed up for or for which you have purchased a license or acquired
            a free trial. MC&E Inc. reserves all other rights in the applicable
            Software not granted to you in writing in this Agreement.
            Conditioned upon your compliance with the terms and conditions of
            this Agreement (including all payment obligations), MC&E Inc. grants
            you a personal, limited, nonexclusive, nontransferable, revocable
            license to use the applicable Software only for the period of use
            provided in the ordering and activation terms (as applicable), as
            set forth in this Agreement or in MC&E Inc.’s then-current product
            discontinuation policies (as updated from time to time) and only for
            the purposes described by MC&E Inc. for the applicable Software.
          </p>
          <p>
            You acknowledge and agree that such Software is licensed, not sold.
          </p>
          <p className="underline">Content and Data</p>
          <p className="italic">
            What’s yours remains yours, what’s ours remains ours, but we may use
            information you provide to improve our Platform.
          </p>
          <p>
            You are solely responsible for anything you write, submit, receive,
            share and store or any data you input into the Platform
            (collectively, your “Content”). Content includes, but is not limited
            to, data, information, materials, text, graphics, images, audio,
            video that are uploaded, transmitted, posted, generated, stored, or
            otherwise made available through the Platform. You have no
            obligation to provide any content to the Platform, and you’re free
            to choose the content that you want to provide. You acknowledge
            certain functionality in the Platform may be dependent on the
            provision of Content and may not be available without such Content.
          </p>
          <p>
            Your Content remains yours, which means that you retain any
            intellectual property rights that you have in your Content. By
            sharing your Content on the Platform, you hereby grant MC&E Inc. a
            license to use your Content, as described in more detail below.
          </p>
          <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
            <li>1. What&#39;s covered</li>
            <p className="pl-5 my-4 ml-9 indent-0">
              This license covers your Content to the extent your Content is
              protected by intellectual property rights.
            </p>
            <li>2. Scope</li>
            <p className="pl-10 my-4 ml-9">This license is:</p>
            <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
              <li>Worldwide, which means it’s valid anywhere in the world;</li>
              <li>
                Non-exclusive, which means you can license your Content to
                others; and
              </li>
              <li>
                Royalty-free, which means there are no fees for this license.
              </li>
            </ul>
            <li className="pt-4">3. Rights</li>
            <p className="pl-10 my-4 ml-9">
              This license allows MC&amp;E Inc. to:
            </p>
            <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
              <li>
                Host, reproduce, distribute, communicate, sublicense and use
                your Content — for example, to save your Content on our systems
                and make it accessible from anywhere you go;
              </li>
              <li>
                Publish or publicly display your Content, if you’ve made it
                visible to others; and
              </li>
              <li>
                Modify and create derivative works based on your Content, such
                as reformatting or translating it.
              </li>
            </ul>
            <li className="pt-4">4. Purpose</li>
            <p className="pl-10 my-4 ml-9">
              This license is for the limited purpose of:
            </p>
            <p className="pl-5 my-4 ml-9 indent-0">
              Operating, providing and improving the Platform, which means
              allowing the Platform to work as designed and creating new
              features and functionalities.
            </p>
            <li>5. Duration</li>
            <p className="pl-5 my-4 ml-9 indent-0">
              This license lasts for as long as your Content is protected by
              intellectual property rights.
            </p>
            <p className="pl-5 my-4 ml-9 indent-0">
              MC&amp;E Inc. may collect, derive or generate deidentified and/or
              aggregated data regarding your usage of or the performance of the
              Platform, including data derived from your Content. MC&amp;E Inc.
              will own all such data and may use this data without restriction,
              including, but not limited to, operating, analyzing, improving or
              marketing MC&amp;E Inc.’s products and services, including the
              Platform.
            </p>
            <p className="pl-5 my-4 ml-9 indent-0">
              As between you and MC&amp;E Inc., MC&amp;E Inc. and its licensors
              retain all right, title or interest in and to the Platform, except
              for the rights granted to you.
            </p>
          </ul>
          <p className="underline">Prohibited Uses</p>
          <p className="italic">
            We expect you to obey the law and follow certain rules in using the
            Platform.
          </p>
          <p>
            MC&amp;E Inc. does not condone or support any activity that is
            illegal, violates the rights of others, harms or damages MC&amp;E
            Inc.’s reputation or could cause MC&amp;E Inc. to be liable to a
            third party. At minimum, you may not use the Platform to:
          </p>
          <ul className="pl-8 space-y-4 list-disc list-inside">
            <li>
              Violate any law, regulation, executive order or ordinance,
              including through actions that give rise to criminal, civil,
              administrative or regulatory liability and/or fines;
            </li>
            <li>
              Post, generate, or share Content that is or may be illegal or
              inappropriate, including material that may be defamatory, obscene,
              harassing, offensive, fraudulent, objectionable, false or
              misleading, or infringing;
            </li>
            <li>
              Transmit any virus, trojan horse or other disruptive or harmful
              software or data;
            </li>
            <li>
              Send any unsolicited or unauthorized advertising, such as spam;
            </li>
            <li>
              Impersonate or misrepresent your affiliation with MC&amp;E Inc.;
            </li>
            <li>
              Reproduce, modify, resell, license, or provide free or
              unauthorized access to the Platform or make the Platform available
              on any file-sharing, virtual desktop or application hosting
              service;
            </li>
            <li>
              Attempt to reverse engineer, decompile or disassemble in any way
              any of the Platform;
            </li>
            <li>
              Engage in unauthorized access, monitoring, interference with or
              use of the Platform or third-party accounts, information
              (including personal information), computers, systems or networks,
              including scraping or downloading content that doesn’t belong to
              you;
            </li>
            <li>
              Use the Platform for general archiving or back-up purposes; or
            </li>
            <li>
              Encourage or enable any other individual to do any of the above or
              otherwise violate this Agreement.
            </li>
          </ul>
          <p>
            We take copyright seriously at MC&amp;E Inc. We respect the
            copyrights of others and expect you to do the same. If you
            repeatedly infringe the copyrights of others, we may terminate your
            account.
          </p>
          <p>
            MC&amp;E Inc. may terminate your use of the Platform based on our
            reasonable suspicion that your activities, business or products are
            objectionable or promote, support or engage in any of the prohibited
            uses described above.
          </p>
          <p>
            MC&amp;E Inc. may (but has no obligation to) monitor the use of the
            Platform or Content and may edit or remove any Content. We may
            disclose any information necessary to satisfy our legal obligations,
            protect MC&amp;E Inc. or its customers or operate the Platform
            properly.
          </p>
          <p className="underline">Community Forums; Feedback</p>
          <p className="italic">
            You may be able to communicate with others through our Platform, but
            please be respectful. Suggestions you provide for improving our
            Platform may be used freely by us.
          </p>
          <p>
            The Platform may include a community forum or other social features
            that enable you to exchange Content and information with other users
            of the Platform and the public. MC&amp;E Inc. does not support and
            is not responsible for the Content in these community forums. Please
            be respectful when you interact with other users. Do not reveal
            information that you do not want to make public. Users may post
            hypertext links to content of third parties for which MC&amp;E Inc.
            is not responsible.
          </p>
          <p>
            You may provide MC&amp;E Inc. your feedback, suggestions or ideas
            for the Platform. You grant MC&amp;E Inc. a perpetual, worldwide,
            fully transferable, sublicensable, irrevocable, fully paid-up,
            royalty-free license to use your feedback, suggestions and ideas in
            any way, including in future modifications of the Platform, other
            products or services, advertising or marketing materials.
          </p>
          <p className="underline">Termination</p>
          <p className="italic">
            You may cancel your account, and MC&amp;E Inc. may suspend or
            terminate your use of the Platform. For mobile apps, removing the
            app may not cancel your subscription or delete your data.
          </p>
          <p>
            This Agreement is effective until your subscription expires or you
            cancel your account or MC&amp;E Inc. terminates this Agreement (or
            your account). MC&amp;E Inc. may terminate this Agreement (and your
            account) or suspend the Platform at any time in our discretion.
          </p>
          <p>
            Please note that removing an MC&amp;E Inc. mobile app from your
            device may not cancel your subscription or delete your data. If you
            want to cancel your subscription for a Service, please follow the
            applicable Service instructions.
          </p>
          <p className="underline">Effect of Termination</p>
          <p className="italic">
            You must stop using the Platform once your subscription expires or
            you cancel your account (or if this Agreement or your account is
            terminated).
          </p>
          <p>
            Upon expiration of your subscription or cancellation of your
            account, or MC&amp;E Inc.’s termination of your account or this
            Agreement, you must immediately stop using the Platform and pay all
            fees for Platform used. No expiration or termination will affect
            your
          </p>
          <p>
            obligation to pay all fees due or that may have accrued through the
            effective date of expiration or termination or entitle you to any
            refund.
          </p>
          <p className="underline">Survival</p>
          <p className="italic">
            There are a few parts of this Agreement that will continue to apply
            after termination.
          </p>
          <p>
            The following Sections will survive any termination, discontinuation
            or cancellation of the Platform or your account: “Your Personal
            Information,” “Payment and Cancellations” (with respect to fees due
            and unpaid), “Content and Data,” “Community Forums; Feedback,”
            “Effect of Termination,” “Disclaimers,” “Limitation of Liability,”
            “Indemnity Obligations,” “Disputes,” and “General Terms
            (Miscellaneous)”.
          </p>
          <p className="underline">MC&amp;E Inc. Communications</p>
          <p className="italic">
            We may contact you from time to time to support your use of the
            Platform.
          </p>
          <p>
            In order to properly support and serve you, we occasionally need to
            reach out and contact you and may do so in a variety of ways such as
            via text message, email or messaging functionality in the Platform.
            We want to provide you options for receiving communications from us,
            and as such, you may opt-in or opt-out of receiving certain types of
            communications from us or sign up to receive certain kinds of
            messages from us, depending on the Platform. You will need to notify
            us of any changes to your contact details to ensure your preferences
            are updated.
          </p>
          <p>
            You may provide us with your telephone number as part of your
            customer record or registration or via other methods. You understand
            and agree that MC&amp;E Inc. may use your telephone number for
            multi-factor authentication (“MFA”), to confirm your identity and
            help protect the security of your account. Part of the MFA identity
            verification process may involve MC&amp;E Inc. sending text messages
            containing security codes to your telephone number. You agree to
            receive these texts from MC&amp;E Inc. containing security codes as
            part of the MFA process. In addition, you agree that MC&amp;E Inc.
            may send automated text messages and pre-recorded voice messages to
            the telephone number you provide for other limited purposes,
            including: providing you with important critical notices regarding
            your use of the Services, or fulfilling a request made by you
            through the Services.
          </p>
          <p className="underline">Third Party Account Information</p>
          <p className="italic">
            MC&amp;E Inc. is not responsible for any account information
            obtained from third parties.
          </p>
          <p>
            When you direct MC&amp;E Inc. to retrieve your account information
            from third parties, you authorize and permit us to use and store
            that information and other information you submit through the
            Platform (such as usernames and passwords) for purposes of providing
            the Platform and Services to you. You grant MC&amp;E Inc. a limited
            power of attorney to access those accounts and retrieve your account
            information, without
          </p>
          <p>
            additional notice to you. MC&amp;E Inc. will be acting as your agent
            and will not be acting on behalf of the third party.
          </p>
          <p>
            MC&amp;E Inc. does not review third party account information for
            accuracy and is not responsible for any issues or expenses resulting
            from such account information, including any inaccuracy, error,
            delay, or non-delivery. For clarity, MC&amp;E Inc. is not
            responsible for any payment processing errors or fees arising from
            inaccurate account information provided by third parties.
          </p>
          <p className="underline">Disclaimers</p>
          <p className="italic">
            We don’t make any warranties about the Platform except as expressly
            stated in this Agreement.
          </p>
          <p className="font-bold ">
            The only warranties we make about the Platform are (1) stated in
            this Agreement, or (2) as provided under applicable laws. The
            Platform is otherwise provided “as-is,” and we do not make any other
            warranties about the Platform. Unless required by law, we do not
            provide implied warranties, such as the implied warranties of
            merchantability, fitness for a particular purpose, or
            non-infringement. We do not warrant that the Platform is error-free,
            secure, or free from any viruses or other harmful components. We
            also do not provide any warranties with respect to data loss or to
            the accuracy, reliability, or availability of the Platform, nor of
            any content (including any Content) or information made available in
            the Platform. If the exclusions for implied warranties do not apply
            to you, any implied warranties are limited to sixty (60) days from
            the date of purchase or delivery of the Platform, whichever is
            sooner.
          </p>
          <p className="underline">Limitation of Liability</p>
          <p className="italic">
            Our liability is limited when it comes to issues you may encounter
            with our Platform.
          </p>
          <p>
            Other than the rights and responsibilities described in this
            Agreement and as allowed by applicable law, MC&amp;E Inc. won&#39;t
            be responsible for any losses.
          </p>
          <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
            <li>
              The total aggregate liability of MC&amp;E Inc. and our third-party
              providers, licensors, distributors or suppliers (“MC&amp;E Inc.
              Parties”) arising out of or relating to this Agreement is limited
              to the greater of: (1) the fees that you paid to use the relevant
              Service(s) in the 12 months before the breach or (2) $100.
            </li>
            <li>
              The MC&amp;E Inc. Parties won&#39;t be responsible for the
              following:
              <ul className="pl-8 ml-5 list-disc list-inside -indent-5">
                <li>
                  Loss of data, profits, revenues, business opportunities,
                  goodwill or anticipated savings;
                </li>
                <li>Indirect, incidental, or consequential loss;</li>
                <li>Punitive damages; or</li>
                <li>
                  Damages relating to failures of telecommunications, the
                  internet, electronic communications, corruption, security,
                  viruses, or spyware.
                </li>
              </ul>
            </li>
          </ul>
          <p>
            The above limitations apply even if the MC&amp;E Inc. Parties have
            been advised of the possibility of such damages. This Agreement sets
            forth your exclusive remedy with respect to the Platform and its
            use.
          </p>
          <p>
            If you&#39;re legally exempt from certain responsibilities,
            including indemnification, then those responsibilities don&#39;t
            apply to you under this Agreement. For example, the United Nations
            enjoys certain immunities from legal obligations, and this Agreement
            doesn&#39;t override those immunities.
          </p>
          <p className="underline">Indemnity Obligations</p>
          <p className="italic">
            If someone sues us because you used the Platform unlawfully or
            didn’t follow our rules, you will be responsible for any harm to us.
          </p>
          <p>
            You will indemnify and hold harmless the MC&amp;E Inc. Parties for
            any losses, damages, judgments, fines, costs and expenses (including
            legal fees) in connection with any claims arising out of or relating
            to your unlawful or unauthorized use of the Platform or violation of
            this Agreement. MC&amp;E Inc. reserves the right, in its sole
            discretion and at its own expense, to assume the exclusive defense
            and control of any claims. You agree to reasonably cooperate as
            requested by MC&amp;E Inc. in the defense of any claims.
          </p>
          <p className="underline">Disputes</p>
          <p className="italic">
            In the event we are unable to resolve any dispute through an
            informal dialogue, a third-party arbitrator or small claims court
            will help us resolve any disputes we might have, and any disputes
            will be resolved on an individual basis rather than as a class
            action.
          </p>
          <p className="font-bold">
            You and MC&amp;E Inc. agree that, except as provided below, any
            dispute, claim or controversy arising out of or relating in any way
            to the Platform or this Agreement (a “Claim”) will be determined by
            binding arbitration or small claims court, instead of in courts of
            general jurisdiction.
          </p>
          <p>
            Either you or MC&amp;E Inc. can seek to have a Claim resolved in
            small claims court if all the requirements of the small claims court
            are satisfied. Either you or MC&amp;E Inc. may seek to have a Claim
            resolved in small claims court in your county of residence or the
            small claims court in closest proximity to your residence, and you
            may also bring a claim in small claims court in the Superior Court
            of Michigan, County of Kent.
          </p>
          <p className="underline">General Terms (Miscellaneous)</p>
          <p>
            This Agreement is the entire agreement between you and MC&amp;E Inc.
            and replaces all prior understandings, communications and
            agreements, oral or written, regarding its subject matter.
          </p>
          <p className="underline">
            Compliance with Global Trade Laws and Restrictions
          </p>
          <p className="italic">
            You are allowed to use the Platform under the laws of the U.S. and
            other applicable territories. The Platform shall not be exported to
            jurisdictions that are subject to government embargos or
            comprehensive sanctions.
          </p>
          <p>
            You agree that you and anyone who uses the Platform, including the
            related website, online services and mobile apps, are not prohibited
            from using the Platform under the laws and regulations of the United
            States or other applicable jurisdiction. For example, you will not
            use, export, re-export, import, sell, release, or transfer the
            Platform, the Software or the Service directly or indirectly, except
            as authorized by United States law, the laws of the jurisdiction
            where the Platform and Software are made available, and any other
            applicable laws and regulations. In particular, but without
            limitation, the Platform, Software, Services, source code, and
            technology may not be exported, or re-exported, transferred, or
            released (a) into any U.S. embargoed and comprehensively sanctioned
            jurisdiction (Cuba, Iran, North Korea, Syria and the Crimea, Donetsk
            (“DNR”), and Luhansk (“LNR”) regions of the Ukraine) and Russia; or
            (b) to anyone included in the U.S. Treasury Department’s list of
            Specially Designated Nationals or on any other applicable restricted
            party lists. You also agree that you will not use the Platform,
            Software and Services for any purposes prohibited by United States
            law. In addition, you certify that neither you nor any principals,
            officers, directors, or any person or entity (including any
            beneficiaries, owners, affiliated and/or associated parties) you
            know to be directly involved with the use of the Platform, Software
            and the Services are not: (a) on any sanctions lists in the
            countries where the Platform, Software and Services are available,
            (b) doing business in any of the U.S. embargoed countries, and (c) a
            military end user as defined in 15 C.F.R § 744.
          </p>
          <p className="underline">Waiver</p>
          <p className="italic">
            If we waive some of our rights under this Agreement, it doesn’t mean
            we waive our rights in other circumstances.
          </p>
          <p>
            MC&E Inc.’s failure to act or enforce any of its rights does not
            constitute a waiver of any of our rights. Any waiver by MC&E Inc. of
            any of the provisions in the Agreement must be made in writing and
            signed by a duly authorized officer of MC&E Inc..
          </p>
          <p className="underline">Severability</p>
          <p className="italic">
            If a court voids a term of this Agreement, the other terms will not
            be affected.
          </p>
          <p>
            If any provision of this Agreement is unlawful, void or
            unenforceable for any reason, then that provision will be severed
            and the remaining provisions will remain in full force and effect.
          </p>
          <p className="underline">Contact Information</p>
          <p>
            If you have any questions about the Platform or this Agreement,
            please contact MC&E Inc. support by telephone at 1-888-742-8037 or
            by written correspondence to 4615 Danvers Drive, SE, Grand Rapids,
            MI 49512.
          </p>
        </div>
      </div>
    </>
  )
}
